(function ($) {
    'use strict';

    var maxheight = 0;
    $('.news--tile-title').each(function () {
        if ($(this).height() > maxheight) {
            maxheight = $(this).height();
        }
    });
    $('.news--tile-title').height(maxheight);

    /*
        $(window).on('load resize', function() {
            
            if ($('body').width() + 30 < 768) {
      
                var maxHeight = -1;

                $('.tile.image--tile.border').each(function() {
                    maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
                });

                $('.tile.image--tile.border').each(function() {
                    $(this).height(maxHeight);
                });

            } else {

                $('.tile.image--tile.border').each(function() {
                    $(this).css('height', 'auto');
                });
            }       

        });
    */




}(jQuery));